import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as estimate from '../estimate'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    constraints: {
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: estimate.RESOURCE.payload.dimension.partialId,
      partialId: estimate.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Number of FTEs',
    isOptional: false,
    name: 'FTEs',
    partialId: PartialId.Standard.create('ftes'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
